import { navigation, NavigationItem,ROUTES } from '@/common/config/navigation';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
  isActive: boolean;
}

const isUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

const findTranslationKey = (path: string): string => {
  // Видаляємо /home з початку шляху якщо він є
  const normalizedPath = path.startsWith('/home/') ? path.replace('/home/', '') : path.replace('/', '');
  
  // Функція для пошуку в масиві навігації
  const findInItems = (items: NavigationItem[]): string | null => {
    for (const item of items) {
      // Перевіряємо поточний елемент
      const itemPath = item.path.replace('/home/', '');
      if (itemPath === normalizedPath || item.path === path) {
        return item.labelKey;
      }
      
      // Перевіряємо вкладені елементи
      if (item.items?.length) {
        const found = findInItems(item.items);
        if (found) return found;
      }
    }
    return null;
  };

  // Спочатку шукаємо в конфігурації навігації
  const allItems = [
    ...navigation.main,
    ...navigation.secondary,
    ...navigation.projects
  ];
  
  const foundKey = findInItems(allItems);
  if (foundKey) {
    return foundKey;
  }

  // Якщо це головна сторінка
  if (path === '/home' || path === ROUTES.HOME) {
    return 'navigation.home';
  }

  // Якщо ключ не знайдено, формуємо його з шляху
  const pathParts = normalizedPath.split('/').filter(Boolean);
  return `navigation.${pathParts.join('.')}`;
};

export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const location = useLocation();
  const { t } = useTranslation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  // Якщо ми на головній сторінці
  if (pathnames.length === 1 && pathnames[0] === 'home') {
    return [
      {
        label: t('navigation.home'),
        path: ROUTES.HOME,
        isActive: true,
      },
    ];
  }

  // Створюємо масив хлібних крихт
  const breadcrumbs = pathnames.map((_, index) => {
    const routePath = `/${pathnames.slice(0, index + 1).join('/')}`;
    const translationKey = findTranslationKey(routePath);
    const label = t(translationKey);
    const isActive = index === pathnames.length - 1;

    return {
      label,
      path: routePath,
      isActive,
    };
  });

  // Додаємо головну сторінку на початок, якщо ми не на ній
  if (pathnames[0] === 'home' && pathnames.length > 1) {
    breadcrumbs[0] = {
      label: t('navigation.home'),
      path: ROUTES.HOME,
      isActive: false,
    };
  }

  return breadcrumbs;
}; 